<div [ngClass]="modeClass" (window:resize)="onWindowResize($event)">
    <ng-container *ngIf="startORend!=3">
        <div class="start-in" *ngIf="!expired">{{lable|translate}}</div>
        <div class="text" *ngIf="expired && startORend==2">
            <!-- <strong> -->
            {{"timer.The auction has ended"|translate}}
            <!-- </strong> -->
        </div>
        <div class="text" *ngIf="expired && startORend==1">
            <!-- <strong> -->
            {{'items-requests.The auction has been started' | translate}}
            <!-- </strong> -->
        </div>
        <div class="count-down" *ngIf="!expired">

            <ng-container>
                <div class="counter">
                    <div class="count-value">{{days !== 0 ? days : '-'}} </div>
                    <div class="count-title">
                        {{getScreenWidth<1200?("timer.D"|translate):("timer.Days"|translate)}} </div>
                    </div>
                    <span>:</span>
                    <div class="counter">
                        <div class="count-value">{{hours !== 0 ? hours : '-'}} </div>
                        <div class="count-title">{{getScreenWidth<1200?("timer.H"|translate):("timer.Hours"|translate)}}</div>
                    </div>
                    <span>:</span>
                    <div class="counter">
                        <div class="count-value">{{minutes !== 0 ? minutes : '-'}} </div>
                        <div class="count-title">{{getScreenWidth<1200?("timer.M"|translate):("timer.Minutes"|translate)}}</div>
                    </div>
                    <span>:</span>
                    <div class="counter">
                        <div class="count-value"
                            [ngClass]="{'text-danger':days == 0 && hours == 0 && minutes == 0 && seconds < 10}">
                            {{seconds !== 0 ? seconds : '-'}}
                        </div>
                        <div class="count-title">{{getScreenWidth<1200?("timer.S"|translate):("timer.Seconds"|translate)}}</div>
                    </div>
                    <ng-content #timeExtended></ng-content>
            </ng-container>


        </div>
    </ng-container>
    <ng-container *ngIf="startORend==3">
        <div class="text"> {{"timer.The auction has ended"|translate}}</div>
    </ng-container>


</div>